var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.03 16.09a8.25 8.25 0 1 1 1.06-1.06l6.19 6.19a.75.75 0 1 1-1.06 1.06l-6.19-6.19Zm1.47-6.34a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0Z"
  })));
};

export default SvgSearch;